export interface INonBillableDefaultJob {
  HrRef: number;
  /** Employee's non-billable default job number (bPREH.udNBJobNum), trimmed; null when not configured. */
  NbJobNumber: string | null;
  /**
   * Employee's non-billable default phase (bPREH.udNBPhase), trimmed; null when not configured.
   * VAC / SICK / HOL must be coded on this phase of NbJobNumber (server #30135).
   * JSON may arrive as nbPhase under camelCase serialization.
   */
  NbPhase?: string | null;
  nbPhase?: string | null;
}
